import { Grid2X2, Home, Search, ShoppingBag, Truck } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { useCart } from "../../contexts/CartContext";

export function MobileNav() {
  const { itemCount } = useCart();
  const { pathname } = useLocation();
  if (pathname.startsWith("/checkout") || pathname.startsWith("/order-success")) return null;
  const links = [
    ["/", "Home", Home],
    ["/products", "Categories", Grid2X2],
    ["/search", "Search", Search],
    ["/cart", "Cart", ShoppingBag],
    ["/track-order", "Track", Truck]
  ] as const;
  return (
    <nav className="mobile-bottom-nav" aria-label="Mobile quick navigation">
      {links.map(([to, label, Icon]) => (
        <NavLink key={to} to={to}>
          <span><Icon />{label === "Cart" && itemCount > 0 && <b>{itemCount}</b>}</span>
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
